import { ICreateProcessoAuditoriaUseCase } from "../../../presentation/useCases/create/create_processo_auditoria_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

// CreateProcessoAuditoriaUseCase


export class CreateProcessoAuditoriaUseCase implements ICreateProcessoAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async createProcessoAuditoria(
   IdAuditoria: number| null, Descricao: string| null, IdFuncionario: number| null, DescResponsavel: string| null, ResponsavelCadastrado: boolean| null, Data: Date| null, Horario: string| null, RequisitoNormativo: string| null, Local: number| null): Promise<void> {
    
    await this.repository.createProcessoAuditoria(
      IdAuditoria, Descricao, IdFuncionario, DescResponsavel, ResponsavelCadastrado, Data, Horario, RequisitoNormativo, Local
    );
  }
}
